import { AfterViewInit, Component, Inject, Input, OnChanges, OnDestroy, OnInit, PLATFORM_ID, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { EventspageService } from '../../eventspage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MetaService } from 'src/app/shared/services/meta.service';
import { CanonicalService } from 'src/app/shared/services/canonical.service';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ToHtmlPipe } from 'src/app/shared/utilities/to-htmlpipe/to-html.pipe';

@Component({
  selector: 'app-event-article-content',
  templateUrl: './event-article-content.component.html',
  styleUrls: ['./event-article-content.component.scss'],
  imports: [CommonModule, ToHtmlPipe],
  encapsulation: ViewEncapsulation.None,
})
export class EventArticleContentComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  @Input() pageData: any;
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router,
    private meta: MetaService,
    private route: ActivatedRoute,
    private canonical: CanonicalService
  ) {
    this.subscriptions = [];
    this.getUrl = this.router.url;
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  subscriptions: Subscription[];
  eventDetailData: any;
  subscribeformData: any;
  hasEventTimeElapsed: boolean = false;
  getUrl: any;
  hubspotFormId: any;
  metaBody = {
    title: '',
    description: '',
    url: '',
    image: '',
    type: '',
  };
  renderHubspotForm(formId: string) {
    try {
      // @ts-ignore
      hbspt.forms.create({
        region: 'na1',
        portalId: '8646839',
        formId: formId ? formId : '4b91f58f-f025-4094-b6ce-7fafbf72bafc',
        target: '#hubspotRegisterForm',
        onFormReady: function ($form:any) {
          const fieldsets = $form[0].querySelectorAll(
            'fieldset.form-columns-2'
          );

          fieldsets.forEach((fieldset:any) => {
            // Change the class to 'form-columns-1'
            const submitButton = $form.find('input[type="submit"].hs-button');
            fieldset.classList.remove('form-columns-2');
            fieldset.classList.add('form-columns-1');

            // Update all input tags under this fieldset to have width: 100%
            const inputs = fieldset.querySelectorAll('input');
            inputs.forEach((input:any) => {
              input.style.width = '100%';
            });
            const allInputs = $form[0].querySelectorAll('.hs-input');
            allInputs.forEach((input:any) => {
              input.style.height = '48px';
              input.style.borderRadius = '10px';
              input.style.border = '1px solid #E6E7E9';
              input.style.background = '#FFF';
            });

            submitButton.css({
              padding: '16px',
              'border-radius': '10px',
              background: ' #359EB4',
              height: '48px',
              'font-size': '15px',
              'font-weight': '600',
              border: 'none',
              width: '100%',
            });
            submitButton.hover(
              function () {
                submitButton.css('background-color', '#2a7e90');
              },
              function () {
                submitButton.css('background-color', '#359eb4');
              }
            );
          });
        },
      });
    } catch (_) {}
  }
  ngOnInit(): void {
    let data = this?.pageData?.fields;
    if(data != null){
      this.hubspotFormId = data?.applyForm?.fields?.formId;
    }
  }
  ngOnChanges(): void {
    let data = this?.pageData?.fields;
    if (data != null) {
      this.subscribeformData = {
        dateTime: data?.dateTime,
        header: data?.applyPanelContentTitle || '',
        text: data?.applyPanelContent || '',
        button: data?.buttons ? data?.buttons[0] : null,
      };
      
      this.hubspotFormId = data?.applyForm?.fields?.formId;
      this.renderHubspotForm(this.hubspotFormId);
      let eventDate = new Date(this.subscribeformData.dateTime);

      let today = new Date();
      let eodDate = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate(),
        23,
        59,
        59
      );
      this.hasEventTimeElapsed = eventDate.getTime() < eodDate.getTime();
      this.eventDetailData = {
        header: data?.title || '',
        speakersDetails: data?.speakersDetails || '',
        dateTime: data?.dateTime || '',
        location: data?.locationDescription || '',
        blogImage: {
          url: data?.blogImage?.fields?.file?.url || '',
          alt: data?.blogImage?.fields?.title || '',
        },
        adPanelTitle: data?.adPanelTitle || '',
        adPanelContent: data?.adPanelContent || '',
        articleContent: data?.articleContent || '',
        relatedEventHeader: data?.subpanelTitle || '',
        relatedEvents: data?.relatedEvents || '',
        button: data?.buttons ? data?.buttons[0] : null,
      };
      if (data?.title) {
        this.metaBody.title = data.title;
      } else {
        this.metaBody.title =
          'Verto: Cross-border payments platform for businesses';
      }
      if (data?.blogContentTop) {
        this.metaBody.description =
          data?.fields?.blogContentTop.content[0].content[0].value;
      } else {
        this.metaBody.description =
          'Verto: Cross-border payments platform for businesses across the globe.';
      }
      this.metaBody.type = 'Blog Article';
      this.metaBody.url = this.getUrl;
      this.metaBody.image = this.eventDetailData?.blogImage?.url;
      this.canonical.setCanonicalURL(this.getUrl);
      this.meta.updateOG(this.metaBody);
      this.meta.updateMeta(data?.seoMetadataReference?.fields ?? this.metaBody);
    }
  }
  ngAfterViewInit() {
    // try {
    //   console.log(this.hubspotFormId, "=============");
    //   // @ts-ignore
    //   hbspt.forms.create({
    //     region: 'na1',
    //     portalId: '8646839',
    //     formId: this.hubspotFormId ? this.hubspotFormId : '4b91f58f-f025-4094-b6ce-7fafbf72bafc',
    //     target: '#hubspotRegisterForm',
    //     onFormReady: function ($form:any) {
    //       const fieldsets = $form[0].querySelectorAll(
    //         'fieldset.form-columns-2'
    //       );

    //       fieldsets.forEach((fieldset:any) => {
    //         // Change the class to 'form-columns-1'
    //         const submitButton = $form.find('input[type="submit"].hs-button');
    //         fieldset.classList.remove('form-columns-2');
    //         fieldset.classList.add('form-columns-1');

    //         // Update all input tags under this fieldset to have width: 100%
    //         const inputs = fieldset.querySelectorAll('input');
    //         inputs.forEach((input:any) => {
    //           input.style.width = '100%';
    //         });
    //         const allInputs = $form[0].querySelectorAll('.hs-input');
    //         allInputs.forEach((input:any) => {
    //           input.style.height = '48px';
    //           input.style.borderRadius = '10px';
    //           input.style.border = '1px solid #E6E7E9';
    //           input.style.background = '#FFF';
    //         });

    //         submitButton.css({
    //           padding: '16px',
    //           'border-radius': '10px',
    //           background: ' #359EB4',
    //           height: '48px',
    //           'font-size': '15px',
    //           'font-weight': '600',
    //           border: 'none',
    //           width: '100%',
    //         });
    //         submitButton.hover(
    //           function () {
    //             submitButton.css('background-color', '#2a7e90');
    //           },
    //           function () {
    //             submitButton.css('background-color', '#359eb4');
    //           }
    //         );
    //       });
    //     },
    //   });
    // } catch (_) {}
  }
  social(a: string) {
    const isServer = !isPlatformBrowser(this.platformId);
    if (isServer) return;
    let title = this.eventDetailData?.header;
    let url = `https://verto.co${this.getUrl}`;
    let twitterHandle = 'Verto';
    let facebook = 'https://facebook.com/sharer/sharer.php?u=' + url;
    let twitter =
      'https://twitter.com/intent/tweet?url=' +
      url +
      '&text=' +
      title +
      '&via=' +
      twitterHandle;
    let linkedin =
      'https://www.linkedin.com/shareArticle?url=' + url + '&title=' + title;

    let b = '';

    if (a === 'linkedin') {
      b = linkedin;
    }
    if (a === 'twitter') {
      b = twitter;
    }
    if (a === 'facebook') {
      b = facebook;
    }

    let params = `width=600,height=400,left=100,top=100`;

    window.open(b, a, params);
  }
}
